import { getStore } from './stores-repository'
import { APP_STORE } from './stores'

export const withSpinner = async (request) => {
    if (!request) {
        return Promise.resolve(undefined)
    }

    let appStore

    try {
        appStore = getStore(APP_STORE)
        appStore.loadingStart()
    } catch (error) {
        appStore = undefined
    }

    try {
        const result = await request
        if (appStore) appStore.loadingStop()
        return Promise.resolve(result)
    } catch (error) {
        if (appStore) appStore.loadingStop()
        return Promise.reject(error)
    }
}
